import { Menu, Anchor, Text } from '@mantine/core'
import { usePage } from '@inertiajs/react'
import { useI18n } from './_i18n'
import { LANGUAGE_NAMES, langTag, relativeAlternate } from './_localePath'

// Language switcher: links to the CURRENT page in each of the 12 languages, using
// the server-shared `alternate_urls` (hreflang -> URL). Uses full-navigation <a>
// links (not Inertia Link) so the target locale renders server-side in-language.
// SEO discovery is handled by the <head> hreflang tags (see _Seo), so this menu
// is purely the human control that replaces the old Accept-Language auto-switch.
export default function LanguageSwitcher({ color = 'inherit', size = 'sm' }) {
  const { locale } = useI18n()
  const { alternate_urls: alternates = {}, site_url: siteUrl = '' } = usePage().props
  const current = langTag(locale)
  const tags = Object.keys(LANGUAGE_NAMES).filter((tag) => alternates[tag])
  if (tags.length < 2) return null

  // Switcher links must stay on the CURRENT host, so use relative paths (the
  // shared alternates are absolute for hreflang). See relativeAlternate.
  const relHref = (tag) => relativeAlternate(alternates[tag], siteUrl)

  return (
    <Menu shadow="md" width={180} position="top-start" withinPortal>
      <Menu.Target>
        <Anchor component="button" type="button" size={size} c={color} underline="never">
          {LANGUAGE_NAMES[current] || 'English'} ▾
        </Anchor>
      </Menu.Target>
      <Menu.Dropdown>
        {tags.map((tag) => (
          <Menu.Item key={tag} component="a" href={relHref(tag)} fw={tag === current ? 700 : 400}>
            <Text size="sm">{LANGUAGE_NAMES[tag]}</Text>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}
